// src/components/home/PartnersSlider.jsx

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import HorizontalScroller from './HorizontalScroller';
import { normalizeMediaUrl } from '../../api/base';

const Card = styled(Link)`
  display: block;
  background: var(--card);
  border: 1px solid var(--bdr);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--shadow);
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
`;

const LogoWrapper = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #fff;
  border-bottom: 1px solid var(--bdr);

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }
`;

const LogoPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  color: var(--primary);
  text-align: center;
  line-height: 1.2;
`;

const Content = styled.div`
  padding: 16px;
`;

const Name = styled.h3`
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg);
  text-align: center;
`;

const Description = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--fg);
  opacity: 0.8;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export default function PartnersSlider({
  items = [],
  perViewDesktop = 4,
  perViewTablet = 2,
  perViewMobile = 1,
  perViewTiny = 1,
  itemMin = 200,
}) {
  if (!items || items.length === 0) return null;

  return (
    <HorizontalScroller
      perViewDesktop={perViewDesktop}
      perViewTablet={perViewTablet}
      perViewMobile={perViewMobile}
      perViewTiny={perViewTiny}
      itemMin={itemMin}
      itemMax={330}
      maxWidth={1400}
      centered
      pad={8}
      gap={12}
      limitDesktopWidth={false}
    >
      {items.map((partner) => (
        <div key={partner.id} style={{ width: 'var(--col-width)', height: '100%' }}>
          <Card to={`/partners/${partner.slug}`}>
            <LogoWrapper>
              {partner.logo ? (
                <img 
                  src={partner.logo} 
                  alt={partner.name}
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <LogoPlaceholder>{partner.name}</LogoPlaceholder>
              )}
            </LogoWrapper>
            <Content>
              <Name>{partner.name}</Name>
            </Content>
          </Card>
        </div>
      ))}
    </HorizontalScroller>
  );
}
